import styled from "styled-components";
import Sidebar from "../components/layoutItems/sidebar/Sidebar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Topbar from "../components/layoutItems/topbar/containers/Topbar";
import PageSubLinks from "../components/layoutItems/pageSubLinks/PageSubLinks";
import {
  handleActiveContainerSelect,
  handleActiveQuestionMark,
  handleActiveSelect,
  handleAdresKayitMapSearchOptionsDropdown,
  handleCustomizer,
  handleNakliyeMaliyetPriceSectionSelect,
  handleSidebar,
  notificationDropdown,
  setNavItemsFromMainLayout,
  setSubLinksFromMainLayout,
  themeDropdown,
  topbarDropdown,
  userRoleDropdown,
} from "../features/layout/layoutSlice";
import { useDispatch, useSelector } from "react-redux";
import ModalLayout from "./ModalLayout";
import { useEffect, useState } from "react";

import { getActiveInput } from "../features/calc/calcSlice";
import { getGarajYogunluk } from "../features/admin/adminSlice";
import SidebarSm from "../components/layoutItems/sidebar-sm/SidebarSm";
import CustomizerContainer from "../components/layoutItems/customizer/CustomizerContainer";
import { getTopBarCompanyInfo } from "../features/companyProfile/companyProfileSlice";
import connectionOn from "../utils/signalR/connectionOn";
import { showModal } from "../features/modal/modalSlice";
import { getAllNotifications, getTopPagesNotificationsCounts, setLoadNotificationAsRead } from "../features/notification/notificationSlice";
import useWindowDimensions from "../hooks/useWindowSize";
import TopbarSm from "../components/layoutItems/topbar/containers/TopbarSm";
import TopbarMobile from "../components/layoutItems/topbar/containers/TopbarMobile";
import { getAdminOrUserClaims} from "../features/companyProfile/companyAuthorizationSlice";
import { expireSession } from "../utils/auth/sessionExpiry";

const MainContainer = styled.div`
  width: 100%;
  height: auto;
  background-color: ${({theme}) => theme.mainBgColor};
  position: relative;
  .main {
    --main-top-offset: ${({isDiffPage, isTopStages, isGarageStatsState}) => isDiffPage ? "0px" : (isTopStages && isGarageStatsState)  ? "210px" : (isTopStages && !isGarageStatsState) ? "175px" : (!isTopStages && isGarageStatsState) ? "100px": "70px"};
    margin-left: ${({sidebarState, isDiffPage}) => sidebarState === "sm-icon" ? "85px" : sidebarState === "wide" ? "300px" : sidebarState === "hidden" && "0"};
    height: ${({isHomePage}) => isHomePage ? "calc(100dvh - var(--main-top-offset))" : "auto"};
    overflow: ${({isHomePage}) => isHomePage ? "hidden" : "visible"};

    margin-top: var(--main-top-offset);
    transition: .5s width;
    //! buradaki bu durumun nedeni modal açıldığında özellikle dark theme de sağ tarafta açıklık oluyor ve beyazlık oluşuyor.
    /* width: ${({ isModalOpen }) =>
      isModalOpen ? "calc(100% - 282px)" : "calc(100% - 300px)"}; */
    background-color: ${({ theme }) => theme.mainBgColor};
  }

  .sidebar-wrapper{
      width: ${({sidebarState}) => sidebarState === "sm-icon" ? "85px" : sidebarState === "wide" ? "300px" : sidebarState === "hidden" && "300px"};
  }

  //! bu etrafı karaltan 
  .upper-layer-sidebar{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 300px;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 15;
  }

  .upper-layer-smIcon{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 22;
  }

  //! bu etrafı karaltan
  .upper-layer-customizer{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 250px;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 299;
  }

  @media (max-width: 850px) {

    .main{
      --main-top-offset: 80px;
      margin-left: 0 !important;
      margin-top: var(--main-top-offset) !important;
      width: 100% !important;
    }

    .sidebar-wrapper{
      width: 0 !important;
    }
  }




`;

const MainLayout = () => {
  const path = useLocation().pathname;
  const dispatch = useDispatch();
  
  //! sayfa yetki kontrolü -**************************************************************
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
  
  const {
    showTopbarDropdown,
    showThemeDropdown,
    showUserRoleDropdown,
    activeSelect,
    activeContainerSelect,
    activeQuesTionMark,
    adresKayitMapSearchOptionsDropdown,
    activeNakliyeMaliyetPriceSectionSelect,
    sidebarState,
    topStagesState,
    garageStatsState,
    customizerState,
    diffPageList,
    mustSmSidebarPageList,
    isSmSidebarHovered,
    showNotificationDropdown,
    navItemsFromMainLayout,
    subLinksFromMainLayout
  } = useSelector((state) => state.layout);
  const { activeInput } = useSelector((state) => state.calc);
  const { modalType } = useSelector((state) => state.modal);
  const {gibLoginData} = useSelector(state => state.eArsiv)

  const {windowDimensions} = useWindowDimensions()

  const {atananlarList, yuklemedeList, seferdeList, bosaltmadaList, tamamlananSeferlerList} = useSelector(state => state.loadList)

  const handleClick = () => {
    if (activeInput) {
      dispatch(getActiveInput(null));
    }

    if(activeNakliyeMaliyetPriceSectionSelect){
      dispatch(handleNakliyeMaliyetPriceSectionSelect(null))
    }
    if (activeSelect) {
      dispatch(handleActiveSelect(null));
    }
    if (activeContainerSelect && !activeSelect) {
      dispatch(handleActiveContainerSelect(null));
    }
    if (activeQuesTionMark) {
      dispatch(handleActiveQuestionMark(null));
    }
    if (showTopbarDropdown) {
      dispatch(topbarDropdown());
    }
    if (showThemeDropdown) {
      dispatch(themeDropdown());
    }
    if (showUserRoleDropdown) {
      dispatch(userRoleDropdown());
    }
    if (adresKayitMapSearchOptionsDropdown) {
      dispatch(handleAdresKayitMapSearchOptionsDropdown());
    }
    if (showNotificationDropdown) {
      dispatch(notificationDropdown());
    }
  };

  // useEffect(() => {
  //   const fetchYandexRoute = async () => {
  //     const from = { lat: 39.925533, lng: 32.866287 }; // Başlangıç
  //     const to   = { lat: 41.015137, lng: 28.979530 }; // Varış (İstanbul)

  //     // Yandex Routing HTTP API çağrısı
  //     const resp = await fetch(
  //       `https://api.routing.yandex.net/v2/distancematrix?origins=25.249269,55.350952|25.248066,55.351206&destinations=25.225335,55.254270|25.230278,55.261586&apikey=${process.env.REACT_APP_YANDEX_MAPS_API_KEY}` +
  //       `&mode=driving&lang=tr` +
  //       `&waypoints=${from.lng},${from.lat}|${to.lng},${to.lat}`
  //     );
  //     const json = await resp.json();

  //     // GeoJSON LineString coords: [ [lng, lat], … ]
  //     const coords = json.features[0].geometry.coordinates
  //       .map(([lng, lat]) => ({ lat, lng }));

  //     console.log(coords);
      
  //   };

  //   fetchYandexRoute().catch(console.error);
  // }, []);

  //! claim çekme ve user claim verme

    const { adminOrUserClaims} = useSelector(state => state.companyAuthorization)

    useEffect(() => {
        dispatch(getAdminOrUserClaims())
    }, [])

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  useEffect(() => {
    const filteredList = adminOrUserClaims?.filter((item) => {
      return item?.name !== "İşlem Adımları"
    })
    const filteredSubLinks = filteredList?.map((item) => {
      return {
        ...item,
        permission: item?.permission?.$values.map((innerItem) => {
          return {
            ...innerItem,
            permissions: innerItem?.permissions?.$values?.map((innerInnerItem) => {
              return {...innerInnerItem}
            })
          }
        })
      }
    })

    const subs = filteredSubLinks?.find((item) => {
      return item.permission.some((innerItem) => {
        return innerItem.slug.split("/")[1] === path.split("/")[1];
      });
    })?.permission;
    

    dispatch(setNavItemsFromMainLayout(filteredSubLinks))
    dispatch(setSubLinksFromMainLayout(subs))
  },[path, adminOrUserClaims])
  
  //! bu bildirim için (signalR)
  useEffect(() => {
    connectionOn()
  },[])


  useEffect(() => {
    dispatch(getAllNotifications());
  },[]);

  useEffect(() => {
    if(rld !== "ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" && rld !== "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228"){
      dispatch(getGarajYogunluk());
    }
  },[rld])

  useEffect(() => {
      dispatch(getTopBarCompanyInfo())
  },[])

  useEffect(() => {
    if(diffPageList.includes(path) || mustSmSidebarPageList.includes(path)){
      dispatch(handleSidebar("sm-icon"))
    }
  },[path])

  useEffect(() => {
    if(windowDimensions?.width > 1500){
      dispatch(handleSidebar("wide"))
    }
    if(windowDimensions?.width <  1500){
      dispatch(handleSidebar("sm-icon"))
    }
    if(windowDimensions?.width > 1500 && (diffPageList.includes(path) || mustSmSidebarPageList.includes(path))){
      dispatch(handleSidebar("sm-icon"))
    }
  }, [windowDimensions])
  
  //! sm-icon
  //! normal

  useEffect(() => {
    if(path === "/atananlar"){
      const filteredList = atananlarList.filter(item => item.waitinLoad?.notificationType === 2)

      dispatch(setLoadNotificationAsRead({shipmentIds: filteredList.map(item => item.id), waitingLoadIds: []}))
    }
    if(path === "/yuklemede"){
      
      const filteredList = yuklemedeList.filter(item => {
        return item.notificationType === 3
      })

      dispatch(setLoadNotificationAsRead({shipmentIds: filteredList.map(item => item.id), waitingLoadIds: []}))
      
    }
    if(path === "/seferde"){
      const filteredList = seferdeList.filter(item => {
        return item.notificationType === 4
      })

      dispatch(setLoadNotificationAsRead({shipmentIds: filteredList.map(item => item.id), waitingLoadIds: []}))
    }
    if(path === "/bosaltmada"){
      const filteredList = bosaltmadaList.filter(item => {
        return item.notificationType === 5
      })

      dispatch(setLoadNotificationAsRead({shipmentIds: filteredList.map(item => item.id), waitingLoadIds: []}))
    }
    if(path === "/tamamlanan-seferler"){
      const filteredList = tamamlananSeferlerList.filter(item => {
        return item.notificationType === 6
      })

      dispatch(setLoadNotificationAsRead({shipmentIds: filteredList.map(item => item.id), waitingLoadIds: []}))
    }

  },[path, atananlarList, yuklemedeList, seferdeList, bosaltmadaList, tamamlananSeferlerList])


    useEffect(() => {
      // dispatch(getTopPagesNotificationsCounts())
      dispatch(getTopPagesNotificationsCounts({companyList: []}));
    },[])

  

  useEffect(() => {
    if(windowDimensions.width <= 850 && path === "/"){
      dispatch(showModal("mobile-menu"))
    }
  },[windowDimensions.width, path])

  //! e-arşiv
  // useEffect(() => {
  //   const firstPartOfPath = path.split("/")[1] 
  //   if(firstPartOfPath === "e-arsiv" && !storage.getItem("gibToken") && !storage.getItem("gibCallId") && !storage.getItem("gibCallIdCount") && !storage.getItem("gibTaxName") && !storage.getItem("gibTaxOffice") && !storage.getItem("gibToken") && !storage.getItem("gibVknTckn") && !storage.getItem("gibUserId")){
  //     dispatch(showModal("gibLogin"))
  //   }
  // },[path])

  useEffect(() => {
    const checkTokenExpiry = () => {
      const storedExpiry = storage.getItem("refreshTokenExpires");
      let refreshTokenExpires = null;

      try {
        refreshTokenExpires = storedExpiry ? JSON.parse(storedExpiry) : null;
      } catch {
        refreshTokenExpires = storedExpiry;
      }

      const refreshTokenExpiryTime = new Date(refreshTokenExpires).getTime();
      if (!refreshTokenExpires || !Number.isFinite(refreshTokenExpiryTime) || refreshTokenExpiryTime <= Date.now()) {
        expireSession();
      }
    };

    checkTokenExpiry();
    const tokenExpiryInterval = window.setInterval(checkTokenExpiry, 3 * 60 * 1000);

    return () => window.clearInterval(tokenExpiryInterval);
  }, [storage]);

  return (
    <>
      <ModalLayout />
      <MainContainer
        isModalOpen={modalType}
        onClick={handleClick}
        sidebarState={sidebarState}
        isDiffPage={diffPageList.includes(path)}
        isTopStages={topStagesState}
        isGarageStatsState={garageStatsState === "open"}
        isHomePage={path === "/"}
      >
        {/* <div className="sidebar-wrapper">
          {
            sidebarState === "wide" || sidebarState === "hidden" ? 
            <Sidebar navItems={navItems}/>:
            <SidebarSm navItems={navItems}/>
          }
        </div> */}

            <div className="sidebar-wrapper">
          {
            (sidebarState === "sm-icon" && windowDimensions.width > 850) && 
            <SidebarSm navItems={navItemsFromMainLayout}/>
          }

          {
            ((sidebarState === "wide" || sidebarState === "hidden") && windowDimensions.width > 850) &&
            <Sidebar navItems={navItemsFromMainLayout}/>
          }
        </div>

        
        {
          (!diffPageList.includes(path) && windowDimensions.width <= 1250 && windowDimensions.width > 850) &&
          <TopbarSm/>
        }

        {
          (!diffPageList.includes(path) && windowDimensions.width > 1250) &&
          <Topbar/>
        }

        {
          windowDimensions.width <= 850 &&
          <TopbarMobile/>
        }


        <div className={`main`}>
          {
            //! burada da aynı navbar da role göre itemleri verdiğimzdeki gibi kullanıcın rolünü ve link in sub item ını kontrol edip ona göre dündüreceğiz
            (subLinksFromMainLayout?.length > 1 && !diffPageList.includes(path) && path !== "/" && windowDimensions.width > 850) && <PageSubLinks subLinks={subLinksFromMainLayout} />
          }

          {
            <Outlet />
          }

        </div>

      {/* //! <İletisimBox/> */}
      
      {
        sidebarState === "hidden" && <div className="upper-layer-sidebar" onClick={() => dispatch(handleSidebar("sm-icon"))}></div>
      }

      {
        customizerState && <div className="upper-layer-customizer" onClick={() => dispatch(handleCustomizer(false))}></div>
      }
      
      {
        isSmSidebarHovered &&
        <div className="upper-layer-smIcon"/>
      }

      </MainContainer>

      {
        customizerState && <CustomizerContainer/>
      }

 
    </>
  );
};

export default MainLayout;
